angular
  .module('app')
  .controller('EditPhotoController', EditPhotoController);

EditPhotoController.$inject = ['Session', 'Upload', '$stateParams', 'Films'];

function EditPhotoController(Session, Upload, $stateParams, Films) {
  var vm = this;
  var url = '';
  var id = $stateParams.id;
  var cat = $stateParams.categoria;
  Session.enableLoading();

  var film = Films.get({id: id, cat: cat}).$promise;
  film.then(function (res) {
    Session.disableLoading();
    vm.film = res;
    vm.film.categoria = $stateParams.categoria;
  });

  vm.thumb = function (file, obj) {
    url = 'api/v2/modify/' + cat + '/' + id + '/' + obj;
    Session.enableLoading();
    if (file) {
      Upload.upload({
        url: url,
        data: {
          file: file
        }
      })
      .then(function () {
        Session.reload();
      }, function (resp) {
        console.log('Error status: ' + resp.status);
      });
    }
  };

  if (!Session.id) {
    Session.go('main.index');
  }
}
